<template>
    <v-form
            v-model="valid"
            row
            justify-center>
        <v-flex xs12>

            <v-flex xs12 pa-2 text-center v-if="avatarPicker != undefined && avatarPicker !== false">
                <image-picker
                        imgLabel="avatar"
                        :default="imgDefault"
                        @change="setAvatar"
                ></image-picker>
            </v-flex>

            <v-flex xs12 pa-1  v-if="!isSimpleSignUp">
                <unique-dni-input
                      ref="dniInput"
                        :onValidationFail="DNIValidationFail"
                        :onChange="onDNIChange"
                        :default-value="dni"
                        @blurDNI="blurDNI = false"
                ></unique-dni-input>
            </v-flex>

            <v-layout wrap>
                <v-flex
                    :class="['xs12', 'pa-1']">
                    <v-text-field
                            :clearable="!isReadOnly"
                            prepend-inner-icon="account_box"
                            v-model="firstName"
                            :rules="firstNameRules"
                            label="Nombre"
                            :readonly="isReadOnly"
                            :required="!isReadOnly"
                    ></v-text-field>
                </v-flex>

                <!-- <v-flex xs12 sm6 pa-1 v-if="isSimpleSignUp">
                    <v-text-field
                            :clearable="!isReadOnly"
                            prepend-inner-icon="account_box"
                            v-model="lastNames"
                            :rules="lastNameRules"
                            label="Apellido(s)"
                            :readonly="isReadOnly"
                            :required="!isReadOnly"
                    ></v-text-field>
                </v-flex> -->

                <v-flex xs12 sm6 pa-1>
                    <v-text-field
                            :clearable="!isReadOnly"
                            prepend-inner-icon="account_box"
                            v-model="lastName"
                            :rules="lastNameRules"
                            label="Apellido Paterno"
                            :readonly="isReadOnly"
                            :required="!isReadOnly"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 pa-1>
                    <v-text-field
                            :clearable="!isReadOnly"
                            prepend-inner-icon="account_box"
                            v-model="motherLastName"
                            :rules="lastNameRules"
                            label="Apellido Materno"
                            :readonly="isReadOnly"
                            :required="!isReadOnly"
                    ></v-text-field>
                </v-flex>

                <!-- <v-flex xs12 sm6 pa-1 v-if="!isSimpleSignUp">
                    <v-text-field
                            :clearable="!isReadOnly"
                            prepend-inner-icon="account_box"
                            v-if="isSimpleSignUp"
                            v-model="lastNames"
                            :rules="lastNameRules"
                            label="Apellido(s)"
                            :readonly="isReadOnly"
                            :required="!isReadOnly"
                    ></v-text-field>
                </v-flex> -->

            </v-layout>

            <v-flex xs12 pa-1>

                <v-text-field
                        :clearable="!isReadOnly"
                        prepend-inner-icon="phone"
                        v-if="!isSimpleSignUp"
                        prefix="(+56)"
                        v-model="phone"
                        mask="# #### ####"
                        :rules="phoneRules"
                        label="Teléfono"
                        :readonly="isReadOnly"
                        :required="!isReadOnly"
                ></v-text-field>

                <v-text-field
                        :clearable="!isReadOnly"
                        prepend-inner-icon="email"
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        :readonly="isReadOnly"
                        :required="!isReadOnly"
                ></v-text-field>

                <v-text-field
                        v-if="!(hidePassword != undefined && hidePassword !== false)"
                        prepend-inner-icon="lock"
                        autocomplete="off"
                        v-model="password"
                        :rules="passwordRules"
                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                        @click:append="showPassword = !showPassword"
                        label="Contraseña"
                        :type="showPassword ? 'text' : 'password'"
                        :readonly="isReadOnly"
                        :required="!isReadOnly"
                ></v-text-field>

                <v-radio-group v-if="!isSimpleSignUp" v-model="gender" row>
                    <v-radio label="Hombre" value="m"></v-radio>
                    <v-radio label="Mujer" value="f"></v-radio>
                </v-radio-group>
            </v-flex>

            <slot name="others"></slot>

            <v-flex xs12 text-right mt-2

            >
            <!-- v-if="!(hideSubmitButton != undefined && hideSubmitButton !== false)" -->
                <v-btn
                    color="primary"
                    @click="submit"
                    :disabled="validateRequired === false ? false : (!valid || isDisabled || blurDNI)"
                    :loading="loading"
                    class="ma-0 white--text"
                    >{{submitLabel || 'Enviar'}}
                </v-btn>
                <!-- :dark="valid && !loading && !isDisabled" -->
            </v-flex>
        </v-flex>

    </v-form>
</template>

<script>

    import UniqueDniInput from '@/components/common/UniqueDniInput'
    import ImagePicker from '@/components/common/ImagePicker'

    import {rutFormat} from '@/utils/Common'

    import {mapState} from 'vuex'

    export default{
        props: [
            'loading',
            'simple',
            'user',
            'avatarPicker',
            'hidePassword',
            'readonly',
            'disabled',
            'hideSubmitButton',
            'submitLabel',
            'submitFn',
            'imgDefault',
            'validateRequired'
        ],
        components: {
            UniqueDniInput,
            ImagePicker
        },
        methods: {
            submit(){
                var vm = this

                if (typeof vm.submitFn == 'undefined') return

                var user = {
                    id: vm.userId || null,
                    email: vm.email || '',
                    birth_date: vm.birthDate || '',
                    first_name: vm.firstName || '',
                    // last_names: (vm.lastName1 + '' + vm.lastName2) || vm.lastNames || '',
                    last_name: vm.lastName,
                    mother_last_name: vm.motherLastName,
                    password: vm.password
                }
                if (this.avatar) {
                    user.avatar = this.avatar
                }

                if(!vm.isSimpleSignUp){
                    user.dni = vm.dni || ''
                    user.gender = vm.gender || 'm'
                    user.phone1 = vm.phone || ''
                }
                vm.submitFn(user)

            },
            setUserDefaults(user = {}){

                var vm = this
                var lastName1, lastName2 = ''
                if (user.last_names) {
                    const lastNames = user.last_names.split(' ')
                    lastName1 = lastNames[0]
                    lastName2 = lastNames.length > 1 ? lastNames[1] : ''
                }

                vm.avatar = null
                vm.userId = user.id || null
                vm.dni = user.dni || ''
                vm.gender = user.gender || 'm'
                vm.firstName = user.first_name || ''
                vm.email = user.email || ''
                vm.phone = user.phone1 || ''
                vm.birthDate = user.birth_date || ''
                vm.password = ''
                vm.lastName1 = lastName1
                vm.lastName2 = lastName2
                vm.lastNames = user.last_names || ''
                vm.lastName = user.last_name || ''
                vm.motherLastName = user.mother_last_name || ''

                vm.$nextTick(function(){
                  if(user.dni) {
                    vm.$refs.dniInput.validateUniqueness()
                  }
                })
            },
            triggerDNIOnFail(err){
                var vm = this
                vm.$emit('dni-validation-fail', err)
            },

            DNIValidationFail(){
                this.triggerDNIOnFail()
            },

            onDNIChange(dni){
                this.dni = rutFormat(dni)
                this.blurDNI = true
            },
            setAvatar(file) {
                this.avatar = file
            },
            validacionfinalDNI() {
            }
        },
        computed: {
            isSimpleSignUp(){
                return this.simple != undefined && this.simple !== false
            },
            isReadOnly(){
                return (this.readonly != undefined && this.readonly !== false) || this.isDisabled
            },
            isDisabled(){
                return this.disabled != undefined && this.disabled !== false
            }
        },
        mounted(){
            if (this.user) {
                this.setUserDefaults(this.user)
            }
        },
        watch: {
            valid(val){
                this.$emit('validation-change', val)
            }
        },
        data(){
            return {
                avatar: null,
                userId: null,
                valid: false,
                dni: '',
                birthDate: '',
                gender: 'm',
                firstName: '',
                email: '',
                phone: '',
                lastName1: '',
                lastName2: '',
                lastNames: '',
                lastName: '',
                motherLastName: '',
                password: '',
                showPassword: false,
                blurDNI: false,
                emailRules: [
                    v => /.+@.+/.test(v) || 'E-mail inválido'
                ],
                phoneRules: [
                    v => /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
                ],
                firstNameRules: [
                    v => !!v && v.length > 2 || 'Debe tener al menos 2 caracteres',
                ],
                lastNameRules: [
                    v => !!v && v.length > 2 || 'Debe tener al menos 2 caracteres',
                ],
                passwordRules: [
                    v => !!v || 'Campo requerido',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres'
                ]
            }
        }
    }
</script>

<style scoped>
    /* .sign-up-wrap {
    } */

    .sign-up-card {
        background-color: rgba(255, 255, 255, .8)
    }

    .loading-container {
        padding: 0;
        height: 2px;
        width: 100%;
    }
</style>
